var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { AccordionHeaderWrapper, TipDescriptionText, TipWrapper, } from "./subcomponents";
export var InlineTip = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (_jsxs("div", { children: [_jsx(TipWrapper, __assign({}, rest, { children: _jsx(TipDescriptionText, { children: _jsx(Inset, __assign({ top: "small" }, { children: _jsx(AccordionHeaderWrapper, { children: _jsx(Body, __assign({ weight: "bold" }, { children: children })) }) })) }) })), _jsx(Stack, { size: "large" })] }));
};
